import { type UiFramework } from '../../../types'
import { RecurrenceCalendar } from '../../RecurrenceCalendar'
import { RecurrenceCalendarWrapper } from '../../RecurrenceCalendarWrapper'
import { RecurrenceEnd } from '../../RecurrenceEnd'
import { RecurrencePeriod } from '../../RecurrencePeriod'
import { RecurrenceSettingsRoot } from '../../RecurrenceSettingsRoot'
import { RecurrenceSettingsSecondary } from '../../RecurrenceSettingsSecondary'
import { RecurrenceTypeDropdown } from '../../RecurrenceTypeDropdown'
import { RecurrenceWhenDropdown } from '../../RecurrenceWhenDropdown'

type Props = {
  uiFramework: UiFramework
  inEditMode: boolean
}

export function RecurrenceSettingsAnnually(props: Props) {
  const { uiFramework, inEditMode } = props
  return (
    <RecurrenceSettingsRoot>
      <RecurrenceCalendarWrapper>
        <RecurrenceTypeDropdown />
        <RecurrenceCalendar inEditMode={inEditMode} />
      </RecurrenceCalendarWrapper>
      <RecurrenceSettingsSecondary uiFramework={uiFramework}>
        <RecurrencePeriod />
        <RecurrenceWhenDropdown />
        <RecurrenceEnd />
      </RecurrenceSettingsSecondary>
    </RecurrenceSettingsRoot>
  )
}
